import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=044bc519&scoped=true"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"
import style0 from "./SignIn.vue?vue&type=style&index=0&id=044bc519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bc519",
  null
  
)

export default component.exports